import { useDropzone } from "react-dropzone";
import { Container, ThumbsContainer, ListThumbs, ThumbInner, Img, DadosAnexo } from './styles'
import { v4 as uuid } from 'uuid'
import { Button } from "@material-ui/core";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconWord from '../../../assets/img/word.png';
import IconPdf from '../../../assets/img/pdf.png';
import IconFile from '../../../assets/img/file.png';
import IconZip from '../../../assets/img/zip.png';
import IconRar from '../../../assets/img/rar.png';
import { useEffect } from "react";
import { useSnackbar } from "notistack"
import webconfig from '../../../webconfig.json'

export default function Dropzone({
    files,
    setFiles,
    clear,
    maxFiles,
    acceptTypeFiles,
    maxSizePerFile
}) {

    const { enqueueSnackbar } = useSnackbar()

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {

            let todosArquivosSaoPermitidos = true
            let ehParaIncluir = true

            if (maxFiles && acceptedFiles.length > maxFiles) {
                todosArquivosSaoPermitidos = false
                enqueueSnackbar(`É permitido fazer upload de no máximo ${maxFiles} arquivos.`, { variant: "warning", autoHideDuration: webconfig.snackbarAutoHideDuration })
            }

            if (acceptTypeFiles) {
                acceptedFiles.forEach(file => {
                    let tipoArquivoPermitido = false

                    acceptTypeFiles.forEach(tipoArquivoAceito => {
                        if (file.type.indexOf(tipoArquivoAceito) !== -1 || file.name.indexOf(tipoArquivoAceito) !== -1)
                            tipoArquivoPermitido = true
                    })

                    if (todosArquivosSaoPermitidos && !tipoArquivoPermitido) {
                        todosArquivosSaoPermitidos = false
                        enqueueSnackbar(`O tipo arquivo ${file.name} não é permitido.`, { variant: "warning", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                })
            }

            if (maxSizePerFile) {
                acceptedFiles.forEach(file => {
                    let tamanhoArquivoPermitido = false

                    if (file.size <= maxSizePerFile)
                        tamanhoArquivoPermitido = true

                    if (todosArquivosSaoPermitidos && !tamanhoArquivoPermitido) {
                        todosArquivosSaoPermitidos = false
                        enqueueSnackbar(`O arquivo ${file.name} possui mais de ${(maxSizePerFile / 1024 / 1024).toFixed(0)} Megabytes.`, { variant: "warning", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                })
            }

            if (!todosArquivosSaoPermitidos)
                ehParaIncluir = todosArquivosSaoPermitidos;

            if (ehParaIncluir) {
                const filesAdd = acceptedFiles.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    id: uuid(),
                    file: file
                }))

                filesAdd.map(inputFile => setFiles(prevState => [
                    ...prevState,
                    inputFile
                ]))
            }
        },
        multiple: maxFiles && maxFiles > 1
    })

    const removeFile = itemFile => setFiles((prevFiles) => prevFiles.filter((inputFile) => inputFile.id !== itemFile.id))

    const obtemUrlImagem = file => {
        if (file.type.length > 0 && file.type.split('/')[0] === 'image') {
            return URL.createObjectURL(file)
        } else {
            var nomeArquivo = String(file.name);
            var extensao = file.type.length > 0 ? String(file.type.split('/')[1]).toLowerCase() : nomeArquivo.toLowerCase().substr(nomeArquivo.lastIndexOf('.') + 1, nomeArquivo.length);
            switch (extensao) {
                case 'doc':
                case 'docx':
                case 'dot':
                case 'dotx':
                case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
                    return IconWord;

                case 'pdf':
                    return IconPdf;

                case 'zip':
                case 'x-zip-compressed':
                    return IconZip;

                case 'rar':
                    return IconRar;

                default:
                    return IconFile;
            }
        }
    }

    const clearFlag = !clear;

    useEffect(() => {
        setFiles([])
    }, [clearFlag, setFiles])

    return (
        <div className="container">
            <Container {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Arraste e solte alguns arquivos aqui ou clique para selecioná-los</p>
            </Container>
            <ListThumbs id="ListThumbs">
                {files.map(file => (
                    <ThumbsContainer id="ThumbsContainer" key={uuid()}>
                        <ThumbInner id="ThumbInner">
                            <Img id="Img" style={{ backgroundImage: `url(${obtemUrlImagem(file)})` }} title={file.name} />
                            <DadosAnexo id="DadosAnexo">
                                <DadosAnexo.Item id="DadosAnexo_Item">
                                    <DadosAnexo.Nome id="DadosAnexo_Nome">{file.name}</DadosAnexo.Nome>
                                    <DadosAnexo.Tamanho id="DadosAnexo_Tamanho">{file.size >= 1048576 ? (file.size / 1048576).toFixed(2) + " MB" : (file.size / 1024).toFixed(2) + " KB"}</DadosAnexo.Tamanho>
                                </DadosAnexo.Item>
                                <Button className="btn-remove-attach" onClick={() => removeFile(file)}><DeleteOutlineIcon /></Button>
                            </DadosAnexo>
                        </ThumbInner>
                    </ThumbsContainer>
                ))}
            </ListThumbs>
        </div>
    );
}